<template>
  <div class="fields fields-no-select" :class="{disabled: loading}" @mouseenter="openState = true" @mouseleave="openState = false">
    <div class="error input-error" v-if="hasError">{{ currentErrorMessage }}</div>
    <div class="input text-input fields" :class="hasValue">
      <input type="text"
             :class="inputClass"
             class="input-finder counters"
             ref="input"
             readonly
             v-model="content"
      />
      <div class="icon">
        <img :src="icon">
      </div>
      <div class="text">
        <div class="title" :class='{noDesc: description === ""}'>{{ title }}</div>
        <div class="description" v-if='description !== ""'>{{ description }}</div>
      </div>
    </div>
    <div class="field-dropdown with-scrollbar" :class="{open: openState}" v-if="equipments.length > 0">
      <div class="list-item "
           v-for="(item, index) in equipments"
           :index="index"
           :key="item.id"
           @click="toggle(item.id)"
           :class="{active: picked.indexOf(item.id) !== -1}"
      >
        <div class="check-button">

        </div>
        <span class="name">{{item.text.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  hasValue,
  initializable,
  withErrors,
  withEventDispatcher,
  withIcon,
  withPlaceholder
} from "./mixins/input.mixin";
import MinusSvg from "./svg/minus-svg";
import PlusSvg from "./svg/plus-svg";
import {mapState} from "vuex";

export default {
  name: "equipment-picker",
  components: {PlusSvg, MinusSvg},
  mixins: [hasValue('content'), withErrors, withIcon, withPlaceholder, withEventDispatcher, initializable],
  computed: {
    ...mapState({
      loading: s => s.equipment.loading,
      equipments: s => s.equipment.equipments,
      picked: s => s.equipment.picked
    })
  },
  props: {
    title: String,
    description: {
      type: String,
      default: ""
    },
    icon: String,
    value: Array
  },
  data() {
    return {
      openState: false
    }
  },
  mounted() {
    this.updateValue(this.value);
    if (!this.loading && this.equipments.length === 0) {
      this.$store.dispatch('equipment/fetch');
    }
    window.addEventListener('app:lang', this.handleLang)
  },
  beforeDestroy() {
    window.removeEventListener('app:lang', this.handleLang);
  },
  methods: {
    handleLang () {
      this.$store.dispatch('equipment/fetch');
    },
    updateValue(value) {
      this.$emit('input', value);
    },
    toggle (id) {
      this.$store.commit('equipment/TOGGLE_PICKED', id);
      this.updateValue(this.picked);
    }
  },
}
</script>

<style scoped>
  .noDesc {
    margin: auto !important;
  }
  .fields.disabled {
    opacity: .5;
    cursor: not-allowed;
  }

  .field-dropdown {
    background: white;
    border: 1px solid black;
    padding: 10px;
    display: grid;
    grid-gap: 10px;
    z-index: 9;
    position: relative;
    max-height: 200px;
    overflow-y: auto;
    width: auto!important;
  }
  .field-dropdown:not(.open) {
    display: none;
  }
  .list-item {
    position: relative;
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 14px auto;
    align-items: center;
    height: 20px;
    cursor: pointer;
  }
  .list-item:last-child {
    padding-bottom: 10px;
  }
  .check-button {
    border: 1px solid black;
    width: 14px;
    height: 14px;
    border-radius: 7px;
    position: relative;
  }
  .list-item:not(.active):hover .check-button::after {
    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    background: var(--orange);
    opacity: .2;
    left: 2px;
    top: 2px;
    border-radius: 5px;
  }
  .list-item.active .check-button::after {
    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    background: var(--orange);
    left: 2px;
    top: 2px;
    border-radius: 5px;
  }
  .list-item span {
    font-size: 1.1em;
  }
</style>




// WEBPACK FOOTER //
// src/components/equipment-picker.vue